import { useBrandLogo, useBrandName } from "app/context/BrandingContext";

interface BrandLogoProps {
  className?: string;
}

/** The partner's logo when whitelabelled, otherwise the Relm logo. */
export default function BrandLogo({ className }: BrandLogoProps) {
  const logo = useBrandLogo();
  const name = useBrandName();

  return <img src={logo} alt={name} className={className ?? "h-[18px] w-auto max-w-[120px] object-contain"} />;
}
